// Constants
import {
	GET_ONGOING_CHALLENGES,
	GET_PAST_CHALLENGES,
	GET_FUTURE_CHALLENGES,
	GET_ALL_CHALLENGES,
	GET_CHALLENGE_DETAIL_INFO,
	GET_MY_CHALLENGES,
	RESET_CHALLENGE_DETAIL_INFO,
	GET_CHALLENGE_PHOTOS,
} from '~/data/constants/challenges-constants';

// Constants
import { HIDE_MODAL } from '~/data/constants/modal-constants';

// Services
import ChallengesServices from '~/data/services/challenges-services';

/**
 * Fetches the list of Current Challenges
 *
 * @export
 * @returns
 */
export function listOngoingChallenges() {
	return dispatch => {
		ChallengesServices.listOngoingChallenges()
			.then(response => {
				// The response comes positive if the users profile data is returned
				if (response.data) {
					dispatch(updateStore(response.data));
				}
				// If something else is returned...
				else {
					console.error('Response: ', response.status);
				}
			})
			// The server will return a 400 error if there is no JESSIONID cookie
			.catch(error => {
				if (error.response === undefined) {
					console.error('Response is undefined: ', error.status);
				} else if (error.response.status === 400) {
					console.error('Response is invalid: ', error.status);
				} else {
					console.error('Error returning the list of current challenges');
				}
			});
	};

	/**
	 * Updates the store with the response data.
	 *
	 * @param {*} currentChallenges
	 * @returns
	 */
	function updateStore(currentChallenges) {
		return {
			type: GET_ONGOING_CHALLENGES,
			current: currentChallenges,
		};
	}
}

/**
 * Fetches the list of Past Challenges
 *
 * @export
 * @returns
 */
export function listPastChallenges() {
	return dispatch => {
		ChallengesServices.listPastChallenges()
			.then(response => {
				// The response comes positive if the users profile data is returned
				if (response.data) {
					dispatch(updateStore(response.data));
				}
				// If something else is returned...
				else {
					console.info('response status: ', response.status);
				}
			})
			// The server will return a 400 error if there is no JESSIONID cookie
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else if (error.response.status === 400) {
					return console.error('Response is invalid');
				} else {
					console.error('Error returning the list of past challenges');
				}
			});
	};

	/**
	 * Updates the store with the response data.
	 *
	 * @param {*} pastChallenges
	 * @returns
	 */
	function updateStore(pastChallenges) {
		return {
			type: GET_PAST_CHALLENGES,
			past: pastChallenges,
		};
	}
}

/**
 * Fetches the list of Upcoming Challenges
 *
 * @export
 * @returns
 */
export function listFutureChallenges() {
	return dispatch => {
		ChallengesServices.listFutureChallenges()
			.then(response => {
				// The response comes positive if the users profile data is returned
				if (response.data) {
					dispatch(updateStore(response.data));
				}
				// If something else is returned...
				else {
					console.info('response status: ', response.status);
				}
			})
			// The server will return a 400 error if there is no JESSIONID cookie
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else if (error.response.status === 400) {
					return console.error('Response is invalid');
				} else {
					console.error('Error returning the list of upcoming challenges');
				}
			});
	};

	/**
	 * Updates the store with the response data.
	 *
	 * @param {*} upcomingChallenges
	 * @returns
	 */
	function updateStore(upcomingChallenges) {
		return {
			type: GET_FUTURE_CHALLENGES,
			upcoming: upcomingChallenges,
		};
	}
}

export function listAllChallenges() {
	let ongoingChallenges;
	let pastChallenges;
	let futureChallenges;

	return dispatch => {
		ChallengesServices.listOngoingChallenges()
			.then(results => {
				if (results.data) {
					ongoingChallenges = results.data;
					return ChallengesServices.listPastChallenges();
				}
			})
			.then(results => {
				if (results.data) {
					pastChallenges = results.data;
					return ChallengesServices.listFutureChallenges();
				}
			})
			.then(results => {
				if (results.data) {
					futureChallenges = results.data;
					dispatch(updateStore(ongoingChallenges, pastChallenges, futureChallenges));
				}
			})
			.catch(error => {
				console.error('Error returning the list of all challenges: ', error.stack);
			});
	};

	function updateStore(ongoing, past, future) {
		return {
			type: GET_ALL_CHALLENGES,
			ongoing,
			past,
			future,
		};
	}
}

/**
 * Find a specific challenge by passing its id
 *
 * @export
 * @param {*} challenge_id
 * @returns
 */
export function getChallengeDetailsInfo(challenge_id) {
	let meta;
	let individualStandings;
	let teamStandings;
	let photosLarge;
	let photosSmall;
	let stats;

	return dispatch => {
		// First, gets the metadata from the challenge id
		ChallengesServices.findChallengeById(challenge_id)
			// 1. Gets the individual scoreboard for that challenge
			.then(results => {
				if (results.data) {
					meta = results.data;
					return ChallengesServices.getIndividualScoreboardForChallenge(challenge_id);
				}
			})
			// 2. And the Team scoreboard
			.then(results => {
				if (results.data) {
					individualStandings = results.data;
					return ChallengesServices.getTeamScoreboardForChallenge(challenge_id);
				}
			})
			// 3. After, it retrieves the large photos associated with this challenge
			.then(results => {
				if (results.data) {
					teamStandings = results.data;
					return ChallengesServices.findLargePhotosByChallengeId(challenge_id);
				}
			})
			// 4. After, it retrieves the small photos associated with this challenge
			.then(results => {
				if (results.data) {
					photosLarge = results.data;
					return ChallengesServices.findSmallPhotosByChallengeId(challenge_id);
				}
			})
			// 5. Also, fetches some stats for the Challenge
			.then(results => {
				if (results.data) {
					photosSmall = results.data;
					return ChallengesServices.findStatsbyChallengeId(challenge_id);
				}
			})
			.then(results => {
				if (results.data) {
					stats = results.data;
					dispatch(updateChallengeStore(meta, individualStandings, teamStandings, photosLarge, photosSmall, stats));
				}
			})
			// The server will return a 400 error if there is no JESSIONID cookie
			.catch(error => {
				console.error('Error returning the list of challenge by id: ', error.stack);
			});
	};

	/**
	 * Updates the store with the response data.
	 *
	 * @param {*} upcomingChallenges
	 * @returns
	 */
	function updateChallengeStore(meta, individualStandings, teamStandings, photosLarge, photosSmall, stats) {
		return {
			type: GET_CHALLENGE_DETAIL_INFO,
			meta: meta,
			photos: {
				large: photosLarge,
				small: photosSmall,
			},
			stats: stats,
			standings: {
				individual: individualStandings,
				team: teamStandings,
			},
		};
	}
}

export function resetChallengeDetailsInfo() {
	return {
		type: RESET_CHALLENGE_DETAIL_INFO,
	};
}

/**
 * Join a specific challenge by passing its id
 *
 * @export
 * @param {*} challenge_id
 * @returns
 */
export function joinChallengeById(challenge_id) {
	return dispatch => {
		ChallengesServices.joinChallengeById(challenge_id)
			.then(results => {
				if (results.data) {
					console.info('join challenge status: ', results.status);
				}
			})
			// The server will return a 400 error if there is no JESSIONID cookie
			.catch(error => {
				console.error(error.stack);
			});
	};
}

/**
 * List all challenges associated with a logged in user.
 *
 * @export
 * @returns
 */
export function listMyChallenges() {
	return dispatch => {
		ChallengesServices.listMyChallenges()
			.then(response => {
				// The response comes positive if the users profile data is returned
				if (response.data) {
					dispatch(updateStore(response.data));
				}
				// If something else is returned...
				else {
					console.info('response status: ', response.status);
				}
			})
			// The server will return a 400 error if there is no JESSIONID cookie
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else if (error.response.status === 400) {
					return console.error('Response is invalid');
				} else {
					console.error('Error returning the list of challenge by id');
				}
			});
	};

	/**
	 * Updates the store with the response data.
	 *
	 * @param {*} upcomingChallenges
	 * @returns
	 */
	function updateStore(myChallenges) {
		return {
			type: GET_MY_CHALLENGES,
			myChallenges: myChallenges,
		};
	}
}

export function deletePhotoByUserIdAndTimestamp(challenge_id, user_id, timestamp) {
	let photosLarge;
	let photosSmall;
	return dispatch => {
		ChallengesServices.deletePhotoByUserIdAndTimestamp(challenge_id, user_id, timestamp)
			.then(results => {
				if (results.data) {
					console.info('Deleted photo status: ', results.status);

					if (results.status === 200) {
						return ChallengesServices.findLargePhotosByChallengeId(challenge_id);
					}
				}
			})
			.then(results => {
				if (results.data) {
					photosLarge = results.data;
					return ChallengesServices.findSmallPhotosByChallengeId(challenge_id);
				}
			})
			.then(results => {
				if (results.data) {
					photosSmall = results.data;
					dispatch(updateStore(photosLarge, photosSmall));
					dispatch(hideModal());
				}
			})
			// The server will return a 400 error if there is no JESSIONID cookie
			.catch(error => {
				console.error(error.stack);
			});
	};

	/**
	 * @description Updates the photos array with new ones
	 * @date 2018-07-13
	 * @param {*} photosLarge
	 * @param {*} photosSmall
	 * @returns
	 */
	function updateStore(photosLarge, photosSmall) {
		return {
			type: GET_CHALLENGE_PHOTOS,
			large: photosLarge,
			small: photosSmall,
		};
	}

	/**
	 * @description Hides the modal from the view
	 * @date 2018-07-13
	 * @returns
	 */
	function hideModal() {
		return {
			type: HIDE_MODAL,
		};
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/challenges-actions.jsx